export const APIURLS = {
  EXECUTION_LOGS_API: "Projects/Ingestion/logs/pipelines",
  TRANSFORMATION_LOGS_API: "Projects/Pipelines/execution-Logs",
  SAVE_REJECTION_RECORDS: "Projects/Pipelines/save-rejection-records",
  REJECTION_BATCHES: "Projects/Pipelines/rejection/batches",
  REJECTION_BATCHES_BY_ID: "Projects/Pipelines/rejection-edit-batch",
  BAD_RECORDS: "Projects/Pipelines/bad-records-status",
  GET_PIPELINE_SCHEDULES:"processScheduler/getSchedules",
  TASK_SAVE: "task/save",
  profiledata: "user",
  ADD_DATA_SOURCES: "data-sources/add-data-sources",
  CREATE_CONNECTION: "/connection",
  CreateAnaplanCA: "./anaplan-cert-connection",
  UPDATE_DATA_SOURCES: "/connection/",
  CreateWorkflow: "/taxonomy/workflow",
  transformationLogs: "/list_transformation_logs",
  UpdateWorkflow: "workflows/update-workflow",
  GET_SINGLE_WORKFLOW: "/taxonomy/viewWorkflowsDetails",
  GetWorkflow: "/taxonomy/workflow",
  // TASK_TRIGGER: 'task/trigger',
  getdatalakecolumn: "/list_columns_in_parquet",
  GETDATALAKELIST: "/datalake/layers",
  GETPROFILERDATA: "/dataprofile/getDataProfile",
  GETFILENAME: "/dataprofile/getFilePath",
  UPDATESTATUSTRANSFORMATIONPIPELINE: "/update_status_transformation_pipeline",

  DISABLE_TASK: "task",
  GETTRANSFORMATIONPIPELINE: "/get_transformation_pipeline",
  EDITTRANSFORMATIONPIPELINE: "/edit_transformation_pipeline",
  DELETETRANSFORMATIONPIPELINE: "/delete_transformation_pipeline",
  TRIGGERPIPELINEDQ: "/send_transformation_params_to_fabric",
  SINGLEMASTERATTRIBUTE: "/entity/master-attributes",

  DELETE: "/taxonomy/delete_workflow",
  TOGGLEWORKFLOW: "/workflows/toggle",
  GETBYID: "/connection",
  ADD_SCHEDULER: "scheduler/add",
  TABLE_DATA_AZURE_BLOB: "utility/table-data-azureblob",
  TABLE_DATA: "utility/table-data",
  DATA_SOURCE_LIST: "data-sources/get-data-sourceList",
  CUSTOM_QUERY: "custom-query",
  LIST_DATA_SOURCE: "/connection",
  // TASK_LOG: 'task/tasklog',
  // TASK_DUMP: 'task/taskdump',
  // TASK_LIST: 'task/list',
  // SCHEDULE_TASK_LIST: 'scheduler/get-scheduler-task-list',
  // TRIGGER_TASK: 'task/trigger',
  // ENABLE_DISABLE_TASK: 'task/disable-task',
  GATEWAY_API: "gateway/register",
  GETGATEWAY_API: "gateway/get-gateways",
  GET_ALL_COUNT: "util/get-all-count",

  //v2
  USERS: "/user",
  LOGIN: "/login",
  CONNECTION: "/connection",
  TEST_CONNECTION: "/test-connection",
  GATEWAY: "/gateway",
  SSOLOGIN: "/sso-login",

  TASK_LOG: "task/task-logs",
  ANAPLAN_LOGS: "anaplan/anaplan-logs",
  TASK_DUMP: "task/taskdump",
  AUDIT_LOGS: "task/audit-logs",
  TASK_LIST: "task",
  SCHEDULE_TASK_LIST: "scheduler",
  TRIGGER_TASK: "task/trigger",
  ENABLE_DISABLE_TASK: "task",
  CONNECTION_LIST: "connection/list",
  // TABLE_LIST: 'data',
  DATA_SOURCES: "connection/datasources",
  CHANGE_PASSWORD: "/user/password",
  GET_ALL_TABLE: "sql",
  ADD_NEW_TASK: "task",
  MASTERLIST: "/master-list",
  TOGGLE_MASTER: "/masters/Toggle",
  MASTERLISTDETAILS: "/master-list/master",
  MASTERDATADETAILS: "/master-data/getALL",
  CREATE_MASTER: "/masters/create",
  MASTERSLIST: "/masters/master-list",
  MASTERDATA: "/master-data",
  GETMASTERDATA: "/masters/read",
  FORMLIST: "/form",
  CREATE_FORM: "/form",
  FORMDATA: "/form_data",
  TAXONOMY: "/taxonomy",
  ENTITYDATA: "/taxonomy/get-all-taxonomy-data",
  APPROVALROLES: "/approverRoles",
  HIERARCHY_RESULT: "/taxonomy/getTaxonomyData",
  UPDATETAXONOMY: "/hierarchyData",
  APPROVALSLIST: "/getListByUserId",
  APPROVERSLIST: "/getListByEntityId",
  RECORDDETAILS: "/recordDetails",
  UPDATEAPPROVAL: "/approval_decision",
  ADD_BRAND: "/master-data",
  ADD_MASTERDATA: "/taxonomy/taxonomyData",
  GET_GOLDENRECORD: "/taxonomy/getGoldenRecord",
  CREATE_GOLDENRECORD: "/taxonomy/goldenRecord",
  PROPOSE_AS_GR: "/taxonomy/approveRequest",
  CANCEL_PROPOSE_AS_GR: "/taxonomy/cancelPropose",
  APPROVAL_LIST_BY_ENTITY_ID: "/taxonomy/ApprovalListByEntityId",
  ALL_MASTER_DATA: "master-data/fetch_master_data",
  GETDESIGNATIONLIST: "/organizationRoles/get_designation",
  GETMappingLIST: "/organizationRoles/mapping",
  GETDEPARTMENTLIST: "/organizationRoles/get_department_data",
  GETLICENSELOGS: "/company/company_logs",
  TOGGLEDEPARTMENT: "/organizationRoles/toggle",
  TOGGLEDESIGNATION: "/organizationRoles/setStatus",
  CREATEDEPARTMENT: "/organizationRoles/create_department",
  CREATEDESIGNATION: "/organizationRoles/designation",
  UPDATEDESIGNATION: "/organizationRoles/designation",
  UPDATEDEPARTMENT: "/organizationRoles",
  CREATEMAPPING: "/organizationRoles/mapping",
  ALL_USER_LIST: "taxonomy/get_user_role_details",
  TAXOMASTERSLIST: "/masters_ByTaxonomyId_masterId",
  GET_LASTLEVEL_GOLDEN_RECORD: "/entity/recordVariant",
  CREATE_RECORD_VARIANT: "entity/create_recordVariant",
  GET_LEVELWISE_GOLDEN_RECORD: "/entity/ColumnVariant",
  PROPOSE_AS_GR_EACH_LEVEL: "master-list/mastersGoldenrecord",
  CREATE_USER: "/company",
  GET_USER: "/company",
  GETACTIVEDEPT: "/organizationRoles/active_department",
  GETDESIG: "/organizationRoles/get_designation",
  GETROLEGROUPLIST: "user/roles_group",
  GETROLEACTIVITY: "user/roles_master",
  CREATEROLEGROUP: "user/roles_group",
  CREATEROLEGRPMAPPING: "user/roles_group_mapping",
  GET_ORGANIZATION_ADMIN_DATA: "user/get_admin_list",
  UPDATE_ORGANIZATION_ADMIN_DATA: "user/update_admin",
  GETTOKENDATA: "company/usersByCompanyId",
  ADD_ORGANIZATION_ADMIN_DATA: "user/create_admin",
  VIEW_MASTER_DATA: "masters/read",
  // VIEW_MASTER_DATA: "master-data/fetch_master_data",
  CHECK_TAXONOMY_DATA: "taxonomy/check_taxonomy_data",
  GET_REPORTS_DATA: "master-list/getMastersData",
  SCHEMADETAILS: "/master-list/schema",
  MASTERAPPROVALHISTORY: "/master-list/getApprovalsHistory",
  TaxonomyAPPROVALHISTORY: "/taxonomy/getTaxonomyApprovalsHistory",
  PARENTCHILDHIERARCHY: "/master-list/masters",
  PARENTHIERARCHY: "/master-list/insertParent",
  INITIATORLIST: "/taxonomy/initiatorAppovals",
  UPDATEPARENTAPPROVAL: "/master-list/updateParentApprovals",
  UPDATEMASTERAPPROVAL: "/master-list/update_approve_request",
  SOURCECONNECTIONLIST: "/connection/list",
  SOURCETABLELIST: "/data/tables",
  CREATE_PIPELINE: "/pipeline",
  ACTIVATE_DEACTIVATE_PIPELINE: "/task/set-status",
  SCHEDULE_PIPELINE: "/scheduler/add",
  TRIGGER_PIPELINE: "/pipeline/trigger",
  SCHEDULER_BY_ONE_PIPELINE: "/scheduler/get",
  GET_ALL_HIERARCHY: "user/get_supervisors",
  VARIANT_DETAILS: "master-data/fetch_master_data_by_guid",
  GET_AUDIT_LOGS: "util/get-grouped-audit-logs",
  GET_FIELD_HISTORY: "/master-data/filter-by-paramter",
  ENTITYTAXONOMY: "/entity",
  WORKFLOWTAXONOMY: "/workflows",
  GET_ENTITY_HIERARCHY_RESULT: "/entity/entity-level-data",
  ENTITY_SCHEMADETAILS: "/entity/schema",
  TAXONOMY_MASTERLIST: "/taxonomy",
  MASTER_MASTERLIST: "/masters",
  GET_ALL_WORKFLOWS: "workflows/workflows-data",
  // GET_ALL_WORKFLOWS: "/workflows/allWorkflows",
  WORKFLOW_INITIATORLIST: "/workflows/initiatorAppovals",
  APPROVAL_LIST_IN_WORKFLOW: "/workflows/getListByUserId",
  REPORTTAXONOMY: "/reports",
  GET_REPORT_HIERARCHY_RESULT: "/reports/report-headers",
  GET_REPORTS_MASTERDATA: "reports/report-data",
  DOWNLOAD_TEMPLATE: "/data-Template/download",
  UPLOAD_TEMPLATE: "/masters/insert-bulk-data",
  GET_SUGGESSION_DETAILS: "/masters/record-references",
  GET_SUGGESSION_DETAILS_TAXONOMY: "/taxonomy/record-references",
  GET_PIPELINE_DETAILS: "/task/updationDetails",

  //
  // CREATE_ROLE:'/user-role-management/create_role',
  // ROLE_LIST:'/user-role-management/roles',
  // UPDATE_ROLE:'/user-role-management/roles',
  // DELETE_ROLE:'/user-role-management/roles',
  // GET_ROLE:'/user-role-management/roles',

  ALL_ROLE_LIST: "/user-role-management/roles",
  CREATE_NEW_ROLE: "/user-role-management/create_role",
  UPDATE_ROLE: "/user-role-management/roles",
  DELETE_ROLE: "/user-role-management/roles",
  ROLE_DETAILS: "/user-role-management/roles",
  GET_MODULES_ROLES: "/user-management/get-all-role-module",
  GET_ROLES_ACTIVITES_LIST: "/user-management/get-all-role-activity",

  // USERS
  CREATE_NEW_USER: "/user-role-management/create_user",
  USER_LIST: "/user-role-management/users",
  DELETE_USER: "/user-role-management/users",
  USER_DETAILS: "/user-role-management/users",
  UPDATE_USER: "/user-role-management/users",
  TOGGLE_USER_GROUP: "/user-management/toggle-group",
  TOGGLE_USER: "/user-role-management/toggle-user",
  TOGGLE_ROLE: "/user-role-management/toggle-role",

  //
  CREATE_USER_GROUP: "/user-management/new-group",
  UPDATE_USER_GROUP: "/user-management/update-group",
  GROUP_LIST: "/user-management/get-all-user-groups",
  DELETE_GROUP: "/user-management/delete-group",
  GROUP_DETAILS: "/user-management/get-user-group",

  GET_PIPELINE_DASHBOARD_CARD_DETAILS: "/pipeline/dashboard/triggerDetails",
  GET_ALL_PIPELINE_DETAILS: "/pipeline/dashboard/triggerName",
  GET_PIPELINE_DETAILS_BY_ID: "/pipeline/dashboard",
  GET_PIPELINE_DETAILS_BY_ID_EDIT: "/pipeline/pipelineDetails",
  pipelineDetails:
    "/pipeline_data/get_pipeline_details_get_all_pipeline_details_get",

  GET_PIPELINE_UPCOMING_TRIGGER_DETAILS:
    "/pipeline/dashboard/scheduledTriggers",
  SKIP_TRIGGER: "/scheduler/skip",
  ADD_PIPELINE_SCHEDULER: "/scheduler",
  PIPELINE_SCHEDULER_LIST: "/scheduler/getSchedulerByTaskId",
  PIPELINE_LOGS_LIST: "/pipeline_logs",
  PIPELINE_LOGS_DETAILS_LIST: "/pipeline",
  PIPELINE_LOGS_DETAILS_LIST_COUNT: "/pipeline/task-logs",
  MASTER_LIST: "/masters/master-list",
  UPDATE_MASTER_DATA: "/masters/update",
  ATTRIBUTES_LIST: "/taxonomy/fetch-attributes",
  CREATE_TAXONOMY: "/taxonomy",
  GET_TARGET_TABLE: "/masters/master-list",
  GET_TARGET_TABLE_COLUMNS: "/pipeline/dashboard/fetch-attributes",
  NEW_ENTITY_LIST: "/entity/entity-list",
  UPDATE_TAXONOMY: "/taxonomy",
  TAXONOMY_MASTER_LIST: "/masters/master-list",
  CREATE_WORKSPACE: "/workspace",
  GET_ENVIRONMENT: "/environment",
  REQUESTAPPROVAL: "/request-approval",
  GETPROJECTSLIST: "/Projects/Settings",
  DELETEPROJECT: "/Projects/Settings/",
  GETPROJECT: "/Projects/Settings",
  GET_TENANTS_LIST: "tenant/tenant-details",
  CREATE_TENANT: "tenant/add",
  UPDATE_TENANT: "tenant/update",
  GET_SUBSRIPTION_LIST: "general-settings/subscriptions",
  GET_RESOURCEGROUP_LIST: "general-settings/resource-groups",
  GET_RESOURCE: "general-settings/resources",
  VALIDATE_TENANT: "tenant/validate",
  TOGGLE_TENANT: "tenant/activate",
  CREATE_RESOURCE_GROUP: "general-settings/create-resource-group",
  CREATE_STORAGE_ACCOUNT: "general-settings/create-storage-account",
  CREATE_DATA_FACTORY: "general-settings/create-data-factory",
  GET_REGIONS: "general-settings/regions",
  GET_STORAGE_TYPES: "general-settings/storage-types",
  CREATE_PROJECT: "Projects/Settings",
  GETLAKEHOUSECOLUMNDATA: "/",
  GETINGESTIONDATAHOUSE: "/datalake/onelake/lakehouses",
  SUBMITDREDIT: "/",
  GETDATALAKETable: "/",
  GETTRANSFORMATIONPIPELINELIST: "/",
  INGESITONSOURCES: "/connection/datasources",
  VALIDATECONNECTION: "/test-connection-1platform",
  UPDATECONNECTION: "/Projects/Connection/",
  CREATECONNECTION: "/Projects/Connection",
  DATA_SOURCES_PROJECT: "/connection/datasources", //one Platform Project
  CREATETARGET: "/",
  GETSOURCECOLUMNLIST: "/",
  GETALLTARGET: "/",
  GETPIPELINECOLUMNAPI: "/Projects/Ingestion/connections/",
  CREATEPIPELINE: "/",
  GETPIPELINEFIELDS: "/",
  UPDATEPIPELINE: "/",
  GET_REPORT_USER_LIST: "/reports/user-list",
  GET_REPORT_MASTER_LIST: "/reports/master-list",
  GET_REPORT_ENTITY_LIST: "/reports/entity-list",
  GET_REPORT_MASTER_DETAILS: "/reports/get-master-details",
  GET_REPORT_MASTER_COLUMNS: "/reports/get-table-columns",
  CREATE_REPORT: "/reports/create-report",
  GET_ALL_REPORTS: "/reports",
  UPDATE_REPORTS: "/reports/edit-report",
  GET_REPORT_ENTITY_DETAILS: "/reports/get-taxonomy-details",
  REPORT_ASSIGN_USER: "/reports/assign-users",
  VIEW_REPORT_DATA: "/reports/get-build-data",
  GET_REPORT_ENTITY_COLUMNS: "/reports/get-taxonomy-columns",
  CREATE_MASTER_DATA_ENTRY: "/masters/insertData",
  GETTARGETCOLUMNLIST: "/data/columns",
  GETSOURCETABLESLIST: "/Projects/Ingestion/connections/",
  UPLOADXML: "/Projects/Ingestion",
  RUNPIPELINESTATUS: "/",
  IngestionPipelineAPI: "/Projects/Ingestion",
  IngestionPipelineEditAPI: "/Projects/Ingestion",
  DELETEPIPELINE: "/Projects/Ingestion",
  TOGGLEPIPELINE: "/",
  RUNPIPELINE: "/Projects/Ingestion/trigger",
  CANCELPIPELINE: "/",
  EXECUTIONlOGSDETAILS: "/",
  GETWORKSPACELIST: "/",
  GETRUNPIPELINEFIELDS: "/",
  GETPIPELINELIST: "/",
  INGESTIONTARGET: "/injestion",
  VALIDATETARGET: "/",
  UPDATETARGET: "/connsction/",
  DATA_Target: "connection/datasources",
  GETCREATEDTARGET: "/Projects/Connection/target",
  DELETETARGET: "/",
  TOGGLETARGETSTATUS: "/Projects/Connection/",
  DELETERESOURCES: "/Projects/Connection/",
  TOGGLESOURCESTATUS: "/Projects/Connection/",
  GetSourcesCreated: "/Projects/Connection/source",
  resourcesColumn: "/",
  resourceGroupColumns: "/",
  EXECUTIONlOGS: "/",
  CREATEDATALAKE: "/datalake",
  DATALAKECREATE: "/datalake/onelake/lakehouses",
  ADDPROCESS: "/processScheduler/addProcess",
  TRIGGERPROCESS: "/processScheduler/triggerProcess",
  UPDATEPROCESSSCHEDULE: "/processScheduler/updateSchedulerById",
  UPDATEPROCESS: "/processScheduler/update-process",
  DELETEPROCESS: "/processScheduler/removeProcessSchedulerById",
  GETPROCESS: "/processScheduler/getProcess",
  getEmbededDetails: '/powerbi/getEmbedToken',
  getdatalakeoptions: "/dataLake/",
  GETDATALAKETABLE: "/data-model/tablename_in_layer",
  GETDIRECTORY: "/data-model/get_directories",
  GETDIRECTORYTABLES: "/data-model/get-tables",
  GETDIRECTORYTABLESCOLUMNS: "/data-model/columns",
  GETDATALAKETABLECOLUMN: "/data-model/columnnames",
  ONEPLATFORM_PIPELINE_ADD_TABLE: '/data-model/table',
  ONEPLATFORM_PIPELINE: '/Projects/Pipelines',
  CREATEONEPLATFORM_PIPELINE: 'transformation/transformation',
  TRANSFORMATION_LOGS: "/Projects/Pipelines/Transformation/Logs",
  ONEPLATFORM_PIPELINE_GETBYID: '/Projects/Pipelines/getById',
  ONEPLATFORM_PIPELINE_UPDATE: '/Projects/Pipelines/updatePipeline',
  ONEPLATFORM_PIPELINE_DELETE: '/transformation/transformation',
  ONEPLATFORM_PIPELINE_TRIGGER: '/Projects/Pipelines/trigger',
  ONEPLATFORM_PIPELINE_SCRIPT: 'transformation/transformation/preview',
  ONEPLATFORM_PIPELINE_LOGS: '/Projects/Pipelines/getPipelineLogs',
  ONEPLATFORM_PIPELINE_SCHEDULE: '/processScheduler/addProcess',
  INGESTIONLOGS: '/Projects/Ingestion/logs/log-list',
  INGESTIONLOGSS: '/processScheduler/getOrchastratorLogs',
  PROCESS_EXECUTION_LOGS: '/processScheduler/execution-logs',
  INGESTIONDETILS: '/Projects/Ingestion/logs',
  TRANSACTIONLOGDATA: '/',
  SUBMITEDITDQ: '/',
  getalldetails: '/powerbi/getReports',
  GOLDER_APPROVAL_LIST: "/compare_data_and_append",
  APPROVE_API: "/approve_changes",
  INITIATED_LIST: "/show_pending_approvals",
  ODATADETAILS: 'odata/get-odata_details',
  WEATHERAPI: 'weather/getWeatherForecastByLocationKey',
  CURRENTCONDITONAPI: 'weather/getCurrentConditionByLocationKey',
  GETREGION: 'weather/getAllRegions',
  GETCOUNTRY: 'weather/getAllCountries',
  GETCITIES: 'weather/getTopCities',
  GETCITUBYAUTOSEARCH: 'weather/autocompleteCitySearch',
  GETADMINAREA: 'weather/getAllAdministrativeAreas',
  GET_ODATA_HEADERS: 'odata/get-headers',
  GET_HEADERS: 'weather/get-headers',
  GET_ALL_BLOB_CONTAINER: "/listAllContainers",
  GET_ALL_BLOB: "/listBlob",
  GET_ALL_BLOB_COLUMNS: "/listAllColumnsInBlob",
  GET_ANAPLAN_COLUMNS: "/anaplan/exportTables",
  GET_ANAPLAN_CA_CERT_COLUMNS: "/anaplan-cert-connection/exportTables",
  GETRULE: '/Projects/Pipelines/expectations',
  GET_DATA_MODEL_SCHEMA: "/data-model/schemas",
  CREATE_MODEL_SCHEMA: "/data-model/create-schema",
  UPDATE_MODEL_SCHEMA: "/data-model/update-schema",
  DELETE_MODEL_SCHEMA: "/data-model/delete-schema",
  GET_RAW_TABLE: "/data-model/get-tables",
  CREATE_DATA_MODEL: "/data-model/data-model",
  GET_DATA_MODEL: "/data-model/genai-model",
  GET_OUTER_SCHEMA: "/data-model/outerSchemas",
  CREATE_OUTER_SCHEMA: "/data-model/outer-schema",
  GET_DEPLOYED_SCHEMA: "/data-model/deploySchema",
  GET_DATA_MODEL_CURRENT_TABLE: "/data-model/getSchemaData",
  DATA_MODEL_DEPLOYMENT_DASHBOARD: "data-model/deploymentDashboard",

  //De duplication
  GET_CONFIGURATION_COLUMNS: '/deduplication/configure/table',
  SAVE_CONFIGURATION: 'deduplication/configure',
  DEDUPLICATION_DASHBOARD: "dashboard/dashboarReport",
  INCOMPLETE_RECORDS: '/dashboard/incomplete-record/:mastername',
  FETCH_CONFIGURATIONS: 'deduplication/configure/fetch-configuration',
  UPDATE_CONFIGURATIONS: 'deduplication/configure',
  REPORT_DASHBOARD: '/deduplication/fetch',
  MERGE_DEDUPLICATION: '/deduplication/execute',
  GET_INSIGHTS_LIST_DUMMY: 'aiplanmaster/getInsights',
  GET_INSIGHTS_LIST: 'aiplanmaster/getInsightByUser',
  GET_PINNED_ITEMS: 'aiplanmaster/getPinnedItems',
  GET_PENDING_ACTIONS: 'aiplanmaster/getPendingActions',
  UPDATE_PINNED_ITEMS: 'aiplanmaster/updatePinnedItems',
  GET_ANOMALY_DETAILS: 'aiplanmaster/getAnamoly',
  GET_DOCUMENT_DATA: 'aiplanmaster/getApprovalDoc',
  APPROVE_REJECT_ANOMALY: 'aiplanmaster/approveRejectAnomaly',
  // ADD_AGENT: 'aiplanmaster/createAgent',
  ADD_AGENT: 'agents',
  GET_AGENTS: 'agents',
  GET_COULUMNTYPE_BY_TABLENAME: '/agents/getColumnsAndDataTypes',
  // GET_AGENTS: 'aiplanmaster/getAgent',
  GET_PROCESS_LIST: 'aiplanmaster/getAgenticProcess',
  GET_AGENT_BY_ID: 'agents',
  CREATE_PROCESS: 'aiplanmaster/createAgenticProcess',
  CREATE_AGENT_ALIGNEMENT: 'aiplanmaster/createAgentAlignment',
  EXECUTE_PROCESS: 'aiplanmaster/executeProcess',
  GET_PROCESS_LOGS: 'aiplanmaster/getProcessLogs',
  CALL_AGENT: 'aiplanmaster/callAgent',
  GET_AGENT_LOGS: 'aiplanmaster/getAgentLogs',
  GET_CONTROL_DASHBOARD: 'aiplanmaster/agenticDashboard',
  DELETE_PROCESS: 'aiplanmaster/deleteProcess',
  GET_MENU_DASHBOARDS: 'aiplanmaster/getDashboardsAndMenus',
  GET_DASHBOARDS: 'aiplanmaster/getDashboards',
  UPDATE_DASHBOARDS_IN_MENU: 'aiplanmaster/updateDashboardsInMenu',
  //Environment
  CREATEENVIRONMENT: '/environment',
  GETENVIRONMENTLIST: '/environment',
  DELETEENVIRONMENT: "/environment",

  //chatbot
  CHATBOTQUERY: "chatbot/query",
  PREVIOUS_CHATS: '/chatbot',

  TAXONOMYATTRIBUTES: "taxonomy/taxonomyattibutes",
  CREATE_WORKFLOW: "workflows/create-workflow",
  FABRIC_TEST_CONNECTION: "Projects/Connection/fabric/test-connection",
  GET_DATANEXUS_HOME_DATA: "Projects/Pipelines/pipelineStats",
  INGESTION_LOGS: "Projects/Ingestion/logs",
  ALLUSERS:"user-role-management/admin/users",
  ALLROLES:"user-role-management/admin/roles",
  GETUSERLIST:"/canvas/usersWithFilterByName",
  TOGGLE_PROCESS_STATUS:'processScheduler/toggle-process-status',
  GET_CANVAS_COLUMN:'/canvas/getColumns',
  GET_CANVAS_PREVIEW:'/canvas/preview',  
  GETPROCESSSCHEDULES:'processScheduler/getschedulesById',
  TRIGGER_MASTERS:'/scheduler/dedup',
  GET_ONE_DEDUP_SCHEDULER:'/scheduler/getDedup',
  DEDUP_STATUS:"dashboard/dedup_status",
  WORKFLOW_USER_LIST:"workflows/users",
  GET_CANVAS_LIST: "/canvas/getCanvases",
  GET_CANVAS_TEMPLATE_LIST: "/canvas/templates",
  CREATE_CANVAS: "/canvas",
  GET_QUERY_DATA:"/canvas/getQuerysData",
  DATA_LAYER_TABLES: "/canvas/dataLayerTables",
  GET_TOTAL_TRIGGER_COUNT: "Projects/Pipelines/get-Trigger-Count",
  GET_AGENTS_LIST: "agents", 
  GET_AGENTS_PERFORMANCE_INDICATOR: "/agents/performance_indicators",
  SAVE_AGENTS_CONFIG: "/agents/configuration",
  DOWNLOAD_DEDUPLICATION:"deduplication/download/:masterId",
  FETCH_GROUPS:"/deduplication/fetch-groups",
  GET_QUERY_VERIFY:"/canvas/getQueryVerify",
  TRIGGER_DEDUPLICATION: "/deduplication/trigger",
  GET_AGENT_OUTPUT: 'agents/getOutput',
  GET_COLUMN_ITEM: 'agents/getColumnItems',
  SAVE_AGENTHOODAI_PREFERENCE: "agents/agent-hood-preference",
  GET_SAMPLE_AGENTS: "agents/sample-agents",
  GENERATE_AGENTS_AI: "agents/generate-agent-ai",

  //Power BI Lineage
  POWER_BI_LINEAGE: 'data-lineage',
  POWER_BI_LINEAGE_ER: 'data-lineage',
  GET_COLUMN_DESCRIPTION: 'agents/getColumnDescription',
};
